module.exports = __webpack_public_path__ + "static/media/menu_items_file_example.beaf942b.xlsx";